import styles from './styles.module.scss'
import { useTranslation } from 'utils/use-translation'

import * as ga from 'libs/ga'

import cn from 'classnames'
import { HTMLAttributes, ReactElement } from 'react'

interface ITabsSliderProps extends HTMLAttributes<HTMLDivElement> {
    tabs: string[] | ReactElement[]
    activeTab: string
    handleTabChange: (tab: string) => void
    type?: 'black' | 'white'
    event?: string
}

const TabsSlider = ({ tabs, activeTab, handleTabChange, type = 'black', className, event }: ITabsSliderProps) => {
    const { t } = useTranslation()

    const activeTabIndex = tabs?.findIndex(tab => tab === activeTab) ?? 1

    return (
        <div className={cn(styles.tabs, { [styles['tabs-white']]: type === 'white' }, className)}>
            <div className={styles.container}>
                <div
                    className={styles.activeTab}
                    style={{
                        width: `${100 / tabs?.length}%`,
                        transform: `translateX(${activeTabIndex * 100}%)`,
                        transition: 'transform 0.3s ease',
                    }}
                ><span>{t(activeTab)}</span></div>
                
                {tabs?.map((tab, id) => (
                    <div
                        key={id}
                        onClick={() => {
                            if (event) {
                                ga.event({
                                    action: event,
                                    params: { target_tab: tab }
                                })
                            }

                            handleTabChange(tab)
                        }}
                        className={`${styles.tab} ${activeTab === tab ? styles.active : ''}`}
                    >
                        <span>{t(tab)}</span>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default TabsSlider